<template>
  <section class="main-box">
    <!--工具条-->
    <el-row class="space_line">
      <el-col :span="12">
        <ProjectList @proSelected="proChange"></ProjectList>
      </el-col>
      <el-col :span="12" align="right">
        <el-button v-on:click="refreshView" type="warning">刷新</el-button>
        <el-button v-on:click="showAddView" type="success">添加模型</el-button>
      </el-col>
    </el-row>
    <!--列表 -->
    <el-row class="HSpace">
      <el-col :span="6" style="margin-bottom: 20px;" v-for="(item,index) in data" :key="index">
        <div class="model_box" @click="openModel(item.id,item.analysisFlag)">
          <div class="model_pic">
            <img src="../../assets/model.png">
          </div>
          <div class="model_label">
            {{item.modelName}}
          </div>
          <el-row class="model_mes">
            <el-col :span="12" class="model_mes_l">
              建模所用工具
            </el-col>
            <el-col :span="12" class="model_mes_r">
              {{item.projectTool}}
            </el-col>
          </el-row>
          <el-row class="model_mes">
            <el-col :span="12" class="model_mes_l">
             上传时间
            </el-col>
            <el-col :span="12" class="model_mes_r">
              {{item.formatTime }}
            </el-col>
          </el-row>
          <el-row class="model_mes">
            <el-col :span="12" class="model_mes_l">
              转码状态
            </el-col>
            <el-col :span="12" class="model_mes_r">
              <span v-if="item.analysisFlag==1" style="color:green;">{{item.analysisFlag | formatFlag}}</span>
              <span v-if="item.analysisFlag==-1" style="color:blueviolet;">{{item.analysisFlag | formatFlag}}</span>
              <span v-if="item.analysisFlag==-2" style="color:red;">{{item.analysisFlag | formatFlag}}</span>
              <span v-if="item.analysisFlag==0" style="color:blueviolet;">{{item.analysisFlag | formatFlag}}</span>
            </el-col>
          </el-row>
        </div>
        <div class="model_tool">
          <el-button type="danger" size="small" @click="doDel(item.id)">删除</el-button>
          <el-button size="small" @click="showEditView(item.id)">编辑</el-button>
          <el-button size="small" type="success" @click="doEngine(item.id)"  style="margin-right: 10px;">执行轻量化</el-button>
        </div>
      </el-col>

    </el-row>
    <!-- 表单视图 -->
    <el-dialog title="" :visible.sync="formVisible" :close-on-click-modal="false" :modal="false">
      <div v-if="formVisible">
          <ModelForm :option="option" @doSubmit="doSubmit" @doCancel="doCancel" :form-data="formData"></ModelForm>
      </div>
    </el-dialog>
    <!-- 模型视图 -->
    <el-dialog :title="model.modelName" :visible.sync="modelVisible" :close-on-click-modal="false"
               :modal="false" width="98%" :top="dialogTop" :fullscreen="dialogFullScreen" @closed="closeEngine" :destroy-on-close="true">
      <div v-if="modelVisible">
<!--        <Engine :data="model" style="height: 760px;"></Engine>-->
            <ModelEngine :model="model"></ModelEngine>
      </div>
    </el-dialog>
  </section>
</template>
<script>
  import { searchModel, deleteModel, detailModel,excuteModel} from '../../api/api'
  import ProjectList from "../command/ProjectList";
  import ModelForm from "./ModelForm";
  import Engine from "./Engine";
  import ModelEngine from "./ModelEngine";


  export default {
    components: {ModelEngine, Engine, ModelForm, ProjectList},
    data() {
      return {
        filters: {proId:null,},
        loading: false,
        total: 2,
        page: 1,
        limit: 15,
        data: [],
        formData: {},
        fileList: [],
        formVisible: false,
        detailId: null,
        proList:[],
        modelVisible:false,
        dialogTop:'2vh',
        dialogFullScreen:false,
        model:{},
      }
    },
    methods: {
      //查询
      searchData: function () {
        this.GLOBAL.checkRole(this.GLOBAL.fun.techModel, this.GLOBAL.option.select, this);
        this.loading = true
        if (this.filters.searchTab == '') {
          this.filters.searchTab = null
        }
        this.filters.proId = this.filters.proId == '' ? null : this.filters.proId;
        searchModel(this.filters, this.GLOBAL.header).then(result => {
          if (result.success) {
            this.data = result.data

            this.loading = false
          }
        })
      },
      doSearch: function () {
        this.searchData()
      },
      resetForm: function () {
        this.filters = {}
      },
      searchPage: function (val) {
        this.page = val
        this.searchData()
      },
      formatDate: function (row, column) {
        return this.GLOBAL.formatTimeToStr(row.createTime, 'yyyy-MM-dd hh:mm:ss')
      },
      //========================================
      //添加视图
      showAddView: function () {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.techModel, this.GLOBAL.option.create, this);
        if (res) {
          this.option = 0;
          this.formData = {projectId:null}
          this.formVisible = true;
        }
      },

      //编辑视图
      showEditView: function (id) {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.techModel, this.GLOBAL.option.update, this);
        if (res) {
          this.option = 1;
          this.detailId = id;
          detailModel({id: id}, this.GLOBAL.header).then(result => {
            if (result.success) {
              this.formData = result.data;
              this.formVisible = true;
            }
          });
        }
      },
      //表单提交后回调
      doSubmit: function () {
        this.searchData();
        this.formVisible = false;
      },
      //表单取消后回调
      doCancel: function () {
        this.formVisible = false;
      },
      //删除
      doDel: function (id) {
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.techModel, this.GLOBAL.option.delete, this);
        if (res) {
          this.$confirm('确认删除该记录吗?', '提示', {
            type: 'warning'
          }).then(() => {
            deleteModel({id: id}, this.GLOBAL.header).then(result => {
              if (result.success) {
                this.$message({
                  message: '删除成功',
                  type: 'success'
                })
                this.searchData()
              }
            })
          }).catch(() => {
          })
        }
      },
      //打开模型
      openModel:function(id,analysisFlag){
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.techModel, this.GLOBAL.option.message, this);
        if (res) {
          this.dialogFullScreen = false;
          if (analysisFlag != 1) {
            this.$message({
              message: '轻量化未完成',
              type: 'error'
            })
          } else {
            detailModel({id: id}, this.GLOBAL.header).then(result => {
              if (result.success) {
                this.model = result.data;
                this.modelVisible = true;
              }
            });
          }
        }
      },
      //关闭模型
      closeEngine:function(){
      },
      //模型全屏
      doFullScreen:function(){
        this.dialogFullScreen = true;
      },
      //执行轻量化
      doEngine:function(id){
        let res = this.GLOBAL.checkRole(this.GLOBAL.fun.techModel, this.GLOBAL.option.create, this);
        if (res) {
          excuteModel({id: id}, this.GLOBAL.header).then(result => {
            if (!result.success) {
              if(result.data==-1 ||result.data==0 ) {
                this.$message({
                  message: '正在轻量化，请勿重复点击',
                  type: 'warning'
                })
              }
              if(result.data==1){
                this.$message({
                  message: '轻量化已完成',
                  type: 'warning'
                })
              }
            }
            this.searchData();
          })
        }
      },
      refreshView:function(){
        this.searchData();
      },
      proChange:function(proId){
        this.filters.proId = proId;
        this.searchData();
      }
    },
    filters: {
      formatFlag: function (status) {
        return status == 1 ? '轻量化完成' : status == -2? '待轻量化':status == -1?'正在轻量化':status == 0?'正在轻量化':'';
      }
    },
    mounted() {
    }
  }
</script>
<style>
.space_line{border-bottom: 1px dashed green; padding-bottom: 10px}
.HSpace{margin-top: 20px;}
.model_box{width:268px;margin: auto;text-align: center;border: 1px solid #ced6e0;height: 326px;cursor: pointer}
.model_pic{}
.model_label{height: 30px; line-height: 30px; background: #F7F7F7;border-bottom: 1px solid #ced6e0;border-top: 1px solid #ced6e0; text-align: center;margin-bottom: 10px;}
.model_mes{height: 30px; line-height: 30px;}
.model_mes_l{text-align: left;padding-left: 15px;}
.model_mes_r{text-align: right;padding-right: 15px;}
.model_tool{
  width:268px;margin: auto; height: 50px; line-height: 50px;background: #F7F7F7;
  border-bottom: 1px solid #ced6e0;
  border-left: 1px solid #ced6e0;
  border-right: 1px solid #ced6e0;
  text-align: right;
}
.fullscreen_btn{float: left;margin-left: 20px; color: #8c939d;font-size: 14px;cursor: pointer;}
.fullscreen_btn:hover{color: #59bde8}

/*.el-dialog__header {*/
/*  padding: 0px 0px 0px 0px;*/
/*}*/
/*.el-dialog__body {*/
/*  padding: 0px 5px 5px 5px ;*/
/*  color: #606266;*/
/*  font-size: 14px;*/
/*  word-break: break-all;*/
/*}*/
/*.el-dialog__headerbtn {*/
/*  position: absolute;*/
/*  top: 8px;*/
/*  right: 20px;*/
/*  padding: 0;*/
/*  background: 0 0;*/
/*  border: none;*/
/*  outline: 0;*/
/*  cursor: pointer;*/
/*  font-size: 16px;*/
/*}*/
</style>



// WEBPACK FOOTER //
// src/components/model/ModelView.vue